import {
  Grid,
  TextField,
  MenuItem,
  Box,
  Typography,
  Select,
  FormControl,
} from "@mui/material";

function Receiver() {
  return (
    <Box>
      <Typography
        sx={{ mb: "16px", fontSize: "14px", color: "#959BA1", fontWeight: 700 }}
      >
        RECEIVER'S INFORMATION
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Box>
            <Typography
              sx={{
                mb: "8px",
                fontSize: "14px",
                color: "#1C2630",
                fontWeight: 500,
              }}
            >
              First Name
            </Typography>
            <TextField fullWidth size="small" />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box>
            <Typography
              sx={{
                mb: "8px",
                fontSize: "14px",
                color: "#1C2630",
                fontWeight: 500,
              }}
            >
              Last Name
            </Typography>
            <TextField fullWidth size="small" />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box>
            <Typography
              sx={{
                mb: "8px",
                fontSize: "14px",
                color: "#1C2630",
                fontWeight: 500,
              }}
            >
              Phone Number
            </Typography>
            <TextField fullWidth size="small" />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box>
            <Typography
              sx={{
                mb: "8px",
                fontSize: "14px",
                color: "#1C2630",
                fontWeight: 500,
              }}
            >
              Email (Optional)
            </Typography>
            <TextField fullWidth size="small" />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box>
            <Typography
              sx={{
                mb: "8px",
                fontSize: "14px",
                color: "#1C2630",
                fontWeight: 500,
              }}
            >
              Address Line 1
            </Typography>
            <TextField fullWidth size="small" />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box>
            <Typography
              sx={{
                mb: "8px",
                fontSize: "14px",
                color: "#1C2630",
                fontWeight: 500,
              }}
            >
              Address Line 2
            </Typography>
            <TextField fullWidth size="small" />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box>
            <Typography
              sx={{
                mb: "8px",
                fontSize: "14px",
                color: "#1C2630",
                fontWeight: 500,
              }}
            >
              Country
            </Typography>
            <FormControl fullWidth size="small">
              <Select labelId="demo-select-small-label" id="demo-select-small">
                <MenuItem value="Select" defaultValue={"select"} disabled>
                  Select
                </MenuItem>
                <MenuItem value={"IN"}>India</MenuItem>
                <MenuItem value={"US"}>United State</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box>
            <Typography
              sx={{
                mb: "8px",
                fontSize: "14px",
                color: "#1C2630",
                fontWeight: 500,
              }}
            >
              State/Province
            </Typography>
            <TextField fullWidth size="small" />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box>
            <Typography
              sx={{
                mb: "8px",
                fontSize: "14px",
                color: "#1C2630",
                fontWeight: 500,
              }}
            >
              City
            </Typography>
            <TextField fullWidth size="small" />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box>
            <Typography
              sx={{
                mb: "8px",
                fontSize: "14px",
                color: "#1C2630",
                fontWeight: 500,
              }}
            >
              Zip Code
            </Typography>
            <TextField fullWidth size="small" />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Receiver;
